// react_component('Settings/Technicians/DeactivateTechnician') resolves this directory through
// require.context in frontend/packs/application.js and mounts its DEFAULT export, so the re-export
// is structural rather than stylistic (same shape as the sibling PushDeviceStatusPanel barrel).
// eslint-disable-next-line no-restricted-exports
export { default } from './DeactivateTechnician';
export * from './types';
